/* [2026-07-11 · Claude · unified-buybox] UI-стейт buy-box. Додавання в кошик робить
   глобальний перехоплювач submit у snippets/cart-drawer.liquid (контракт §3 ТЗ). */
(function () {
  'use strict';
  var fmt = function (n) { return new Intl.NumberFormat('uk-UA').format(n) + ' ₴'; };

  function initBox(box) {
    if (box.__rbbInit) return;
    box.__rbbInit = true;
    var q = function (s) { return box.querySelector(s); };
    var idInput = q('[data-rbb-id]');
    var qtyInput = q('[data-rbb-qty]');
    var els = {
      total: q('[data-rbb-total]'), was: q('[data-rbb-was]'), save: q('[data-rbb-save]'),
      badge: q('[data-rbb-badge]'), pct: q('[data-rbb-pct]'),
      ctaPrice: q('[data-rbb-cta-price]'), ctaWas: q('[data-rbb-cta-was]'),
      stPrice: q('[data-rbb-sticky-price]'), stWas: q('[data-rbb-sticky-was]'),
      stLabel: q('[data-rbb-sticky-label]'), stOff: q('[data-rbb-sticky-off]'),
      shipWrap: q('[data-rbb-ship-wrap]'), shipFill: q('[data-rbb-ship-fill]'), shipTxt: q('[data-rbb-ship-txt]')
    };
    var fsThreshold = parseInt(box.dataset.fsThreshold, 10) || 0;

    // прогрес безкоштовної доставки (логіка з ca-01-buybox)
    function updateShip(price) {
      if (!els.shipTxt || fsThreshold <= 0) { if (els.shipWrap) els.shipWrap.style.display = 'none'; return; }
      var pct = Math.max(0, Math.min(100, Math.round(price / fsThreshold * 100)));
      if (els.shipFill) els.shipFill.style.width = pct + '%';
      els.shipTxt.innerHTML = price >= fsThreshold
        ? 'Безкоштовна доставка включена'
        : 'ще <b>' + fmt(fsThreshold - price) + '</b> до безкоштовної доставки';
    }

    function apply(d) {
      var price = parseInt(d.price, 10) || 0;
      var was = parseInt(d.was, 10) || 0;
      var save = was > price ? was - price : 0;
      var pct = save > 0 ? Math.round((save / was) * 100) : 0;
      if (idInput && d.vid) idInput.value = d.vid;
      if (qtyInput) qtyInput.value = parseInt(d.qty, 10) || 1;
      if (els.total) els.total.textContent = fmt(price);
      var wasTxt = save > 0 ? fmt(was) : '';
      [els.was, els.ctaWas, els.stWas].forEach(function (el) {
        if (!el) return;
        el.textContent = wasTxt;
        el.hidden = !save;
      });
      if (els.save) { els.save.textContent = '−' + fmt(save); els.save.hidden = !save; }
      if (els.badge) {
        els.badge.hidden = !pct;
        if (els.pct) els.pct.textContent = pct;
      }
      if (els.ctaPrice) els.ctaPrice.textContent = fmt(price);
      if (els.stPrice) els.stPrice.textContent = fmt(price);
      if (els.stLabel && d.label) els.stLabel.textContent = d.label;
      if (els.stOff) { els.stOff.textContent = '−' + pct + '%'; els.stOff.hidden = !pct; }
      updateShip(price);
    }

    // селектор-картки
    var sel = q('[data-rbb-selector]');
    if (sel) {
      sel.addEventListener('click', function (e) {
        var card = e.target.closest('.rute-bb__card');
        if (!card || card.disabled) return;
        sel.querySelectorAll('.rute-bb__card').forEach(function (c) { c.classList.remove('active'); });
        card.classList.add('active');
        apply(card.dataset);
      });
      var act = sel.querySelector('.rute-bb__card.active:not([disabled])') || sel.querySelector('.rute-bb__card:not([disabled])');
      if (act) { act.classList.add('active'); apply(act.dataset); }
    }
    // [v7] смак + паки: вибір смаку перераховує ціни пак-рядків від ціни варіанта
    var flavors = q('[data-rbb-flavors]');
    if (flavors && sel) {
      flavors.addEventListener('click', function (e) {
        var f = e.target.closest('.rute-bb__flavor');
        if (!f) return;
        flavors.querySelectorAll('.rute-bb__flavor').forEach(function (c) { c.classList.remove('active'); });
        f.classList.add('active');
        var fp = parseInt(f.dataset.fprice, 10) || 0;
        var fw = parseInt(f.dataset.fwas, 10) || fp;
        sel.querySelectorAll('.rute-bb__card').forEach(function (row) {
          var qty = parseInt(row.dataset.qty, 10) || 1;
          var pct = parseInt(row.dataset.pct, 10) || 0;
          var price = Math.round(fp * qty * (100 - pct) / 100);
          var was = fw * qty;
          row.dataset.vid = f.dataset.fvid;
          row.dataset.price = price;
          row.dataset.was = was > price ? was : 0;
          var pr = row.querySelector('.rute-bb__row-prices');
          if (pr) pr.innerHTML = (was > price ? '<s>' + fmt(was) + '</s> ' : '') + '<b>' + fmt(price) + '</b>';
          var sv = row.querySelector('.rute-bb__row-save');
          if (sv) { sv.textContent = 'Економія ' + fmt(was - price); sv.hidden = was <= price; }
          var un = row.querySelector('.rute-bb__row-unit b');
          if (un) un.textContent = fmt(Math.round(price / qty));
        });
        var act = sel.querySelector('.rute-bb__card.active') || sel.querySelector('.rute-bb__card');
        if (act) apply(act.dataset);
      });
    }

    // dropdown-layout (A/B)
    var dd = q('[data-rbb-select]');
    if (dd) {
      var applyOpt = function () {
        var o = dd.options[dd.selectedIndex];
        if (o) apply({ vid: o.value, price: o.dataset.price, was: o.dataset.was, qty: 1, label: o.dataset.label });
      };
      dd.addEventListener('change', applyOpt);
      applyOpt();
    }

    // sticky видимість: головна CTA поза вʼюпортом
    // (переносимо в body: fixed ламається всередині transform-предків теми)
    var sticky = q('[data-rbb-sticky]');
    var cta = q('[data-rbb-cta]');
    if (sticky && sticky.parentNode !== document.body) document.body.appendChild(sticky);
    var alwaysSticky = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    if (sticky && alwaysSticky) { sticky.classList.add('visible'); sticky.setAttribute('aria-hidden', 'false'); }
    if (sticky && cta && !alwaysSticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0 }).observe(cta);
    }

    // живий відлік до відправки (cutoff за Києвом); після — «Відправка завтра»
    var dl = q('[data-rbb-delivery]');
    if (dl) {
      var shipEl = dl.querySelector('[data-rbb-ship]');
      var cdEl = dl.querySelector('[data-rbb-countdown]');
      var cutoff = parseInt(dl.dataset.cutoff, 10) || 16;
      var tick = function () {
        try {
          var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Kyiv' }));
          var mins = cutoff * 60 - (now.getHours() * 60 + now.getMinutes());
          if (mins > 0) {
            var h = Math.floor(mins / 60), m = mins % 60;
            if (shipEl) shipEl.textContent = 'Відправка сьогодні';
            if (cdEl) cdEl.textContent = 'замов протягом ' + (h > 0 ? h + ' год ' : '') + m + ' хв';
          } else {
            if (shipEl) shipEl.textContent = 'Відправка завтра';
            if (cdEl) cdEl.textContent = 'Замов до 16:00';
          }
        } catch (e) {}
      };
      tick();
      setInterval(tick, 30000);
    }

    // анти-дабл-клік: клік по CTA < 1.5с після попереднього — preventDefault до submit
    var dblGuard = function (e) {
      var btn = e.target.closest('.rute-bb__cta[type="submit"], [form][type="submit"]');
      if (!btn) return;
      var now = Date.now();
      if (box.__rbbLastAdd && now - box.__rbbLastAdd < 1500) { e.preventDefault(); return; }
      box.__rbbLastAdd = now;
    };
    box.addEventListener('click', dblGuard, true);
    if (sticky) sticky.addEventListener('click', dblGuard, true);

    // «✓ Додано» 1.4с після відкриття drawer
    var form = q('form[action*="/cart/add"]');
    if (form && cta) {
      form.addEventListener('submit', function () {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer) return;
        var orig = cta.innerHTML;
        var done = false;
        var obs = new MutationObserver(function () {
          if (done || !drawer.classList.contains('active')) return;
          done = true;
          obs.disconnect();
          cta.classList.add('is-added');
          cta.innerHTML = '✓ Додано';
          setTimeout(function () { cta.classList.remove('is-added'); cta.innerHTML = orig; }, 1400);
        });
        obs.observe(drawer, { attributes: true, attributeFilter: ['class'] });
        setTimeout(function () { if (!done) { done = true; obs.disconnect(); } }, 8000);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-rbb]').forEach(initBox);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
